var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container-user-agreement",
      style: `paddingTop:${_vm.barHeight}px`,
    },
    [
      _c("van-nav-bar", {
        staticClass: "van-bar",
        attrs: { title: "", "left-arrow": "" },
        on: { "click-left": _vm.closeWeb },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("img", {
                  staticClass: "left-nav",
                  attrs: {
                    src: require("@/assets/packageAssets/common/arrow05.png"),
                    alt: "",
                  },
                  on: { "click-left": _vm.closeWeb },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("div", {
        staticClass: "main",
        domProps: { innerHTML: _vm._s(_vm.$t("lang.user.content")) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }